module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"password":"Password","passwordRepeat":"Repeat password","maxLength":"Minimal 8 character"},"es":{"password":"Contraseña","passwordRepeat":"Repetir contraseña","maxLength":"Mínimo 8 caracteres"}}')
  delete Component.options._Ctor
}
